export enum KsefReceiveSubmissionMode {
	Unknown = 'Unknown',
	Online = 'Online',
	Offline = 'Offline'
}